import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import TextInput from '../../core/TextInput';
import TextAreaInput from '../../core/TextAreaInput';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { FileHelper } from '../../../utils/FileHelper';
import { ValidationErrorPopup } from '../components/ValidationErrorPopup';
import { ConnectionDetailsSection } from '../sections/ConnectionDetailsSection';

interface ConnectionStepLocalProps {
    goToNextStep: () => void;
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;    
    connectionData?: {
        host: string;
        username: string;
        sshKey: string;
        directoryPath: string;
    } | null;
}

type ConnectionStepProps = ConnectionStepLocalProps & ToxnotComponentProperties;

interface ConnectionStepState {
    showValidationError: boolean;
    validationErrorMessage: string;
}

class ConnectionStepComponent extends ToxnotComponent<ConnectionStepProps, ConnectionStepState> {
    constructor(props: ConnectionStepProps) {
        super(props);
        this.state = {
            showValidationError: false,
            validationErrorMessage: ''
        };
    }

    private isFormValid = () => {
        const { fileName } = this.props.configData;
        if (fileName.trim() === '') {
            return false;
        }

        return true;
    }

    private handleNextStep = () => {
        const { fileName, subPath } = this.props.configData;
        
        // Validate file path combination
        const pathValidation = FileHelper.validateFilePathCombination(fileName, subPath);
        if (!pathValidation.isValid) {
            this.setState({
                showValidationError: true,
                validationErrorMessage: pathValidation.errorMessage || 'Invalid file path.'
            });
            return;
        }
        
        this.props.goToNextStep();
    }

    private closeValidationError = () => {
        this.setState({
            showValidationError: false,
            validationErrorMessage: ''
        });
    }

    public render() {
        const { configData, onConfigChange, connectionData } = this.props;

        return (
            <div>
                <div className="grouped-data">
                    <ConnectionDetailsSection connectionData={connectionData} />
                    <div className="group">
                        <div className="title">{this.localizeString("File Path")}</div>
                        <div className="content">
                            <div className="form-group">
                                <label>{this.localizeString("Remote Directory")}</label>
                                <TextInput value={connectionData?.directoryPath || this.localizeString('Loading...')} onValueChange={() => { }} disabled />
                            </div>
                            <div className="form-group">
                                <label>{this.localizeString("Sub Path (Optional)")}</label>
                                <TextInput placeholder={"folder"} value={configData.subPath} onValueChange={newValue => onConfigChange({ subPath: newValue })} />
                            </div>
                            <div className="form-group">
                                <label>{this.localizeString("File Name")}</label>
                                <TextInput placeholder={"import.csv"} value={configData.fileName} onValueChange={newValue => onConfigChange({ fileName: newValue })} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-right" style={{ marginTop: '15px' }}>
                    <button className="btn btn-toxnot-primary" onClick={this.handleNextStep} disabled={!this.isFormValid()}>{this.localizeString("Next")}</button>
                </div>
                
                {/* Validation Error Popup */}
                <ValidationErrorPopup 
                    show={this.state.showValidationError}
                    message={this.state.validationErrorMessage}
                    onClose={this.closeValidationError}
                />
            </div>
        );
    }
}

export const ConnectionStep = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ConnectionStepComponent);